<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">Hi~ <a class="font3">{{ ReportData.stuname }}</a></p>
        <p  class="font1" style="padding-top: 2vh;"><a class="font3">{{ ReportData.mtimedate }}</a>是你开启职场生活的第一天，不知不觉，你已经在富士康这个大家庭生活工作了<a class="font3">{{ workdays }}</a>天。</p>

        <p class="font1" v-if="ReportData.studate !==null" style="padding-top: 4vh;text-align: center;">你已经学习了<a class="font3">{{ ReportData.studate }}</a>天</p>
        <p class="font1" v-if="ReportData.playtime !==null" style="text-align: center;">累计学习了<a class="font3">{{ ReportData.playtime }}</a>小时</p>

        <p class="font1" style="margin: 0 auto;padding-top: 1.5vh;" v-if="ReportData.studate ===null">你还没有在富学宝典上学习<br>请继续加油！</p>
       

        <p style="padding-top: 3vh;margin: 0;text-align: center;font-size: 18px;">你付出了努力，也收获了成长</p>
        <p style="margin: 0;text-align: center;font-size: 18px;">这些学习时光是你未来职业发展的坚实基石</p>

        <p style="padding-top: 3vh;margin: 0;text-align: center;font-size: 18px;">每一天学习都是成长的积累，</p>
        <p style="margin: 0;text-align: center;font-size: 18px;">愿你在这里绽放光芒！</p>

        <p style="font-size: 15px;text-align: center;margin-top: 5vh;margin-bottom: 0;">七月的学习报告已为你生成</p>
        <p style="font-size: 15px;text-align: center;margin: 0;">左滑查看更多内容！</p>
    </div>
</template>
  
<script>

export default {
    props: [ "ReportData"],
    data() {
        return {   
            hireday:'',
            workdays:''
        }
    },
    created() {
      const dateTime = new Date(this.ReportData.mtimedate)
      const dateOnly = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()+1);
      this.hireday = dateOnly.toISOString().split('T')[0]
      const currentDate = new Date()
      const timeDifference = currentDate.getTime() -dateOnly.getTime();
      this.workdays = Math.floor(timeDifference / (1000 * 60 * 60 * 24))+1;
    }
}
</script>
  
<style scoped>       
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/logo2.png") right  top  no-repeat,
                url("../../assets//24July/icon1.png") 49% calc(100% + 30px) no-repeat,
                url("../../assets/24July/bg1.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px, 55%,cover;
    width: 100%;
    height: 100vh;
}

.font1 {
    width: 92%;
    margin: 0 auto;
    text-align: left;
    font-size: 20px;
    color: #000;
    /* font-weight: bold; */
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    color: #000;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #176ed2;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>